export const environment = {
  launchDarklyClientId: '6411be7b176f35123238af99', // gitleaks:allow
};
